import request from '@/api/request.js'

const apis = {
  readFeatures(params) {
    return request({ url: `/admin_license/readFeatures`, method: 'GET', params })
  },
  saveFeature(params) {
    return request({ url: `/admin_license/saveFeature`, method: 'POST', data: params })
  },
  readPlans(params) {
    return request({ url: `/admin_license/readPlans`, method: 'GET', params })
  },
  readPlan(params) {
    return request({ url: `/admin_license/readPlan`, method: 'GET', params })
  },
  savePlan(params) {
    return request({ url: `/admin_license/savePlan`, method: 'POST', data: params })
  },
  copyPlan(params) {
    return request({ url: `/admin_license/copyPlan`, method: 'POST', data: params })
  },
}

export default apis
